import React from 'react';
import { HeroSection } from '../components/sales/HeroSection';
import { ProblemSection } from '../components/sales/ProblemSection';
import { MechanismSection } from '../components/sales/MechanismSection';
import { SolutionSection } from '../components/sales/SolutionSection';
import { OfferSection } from '../components/sales/OfferSection';
import { SocialProofSection } from '../components/sales/SocialProofSection';
import { FAQSection } from '../components/sales/FAQSection';
import { CTASection } from '../components/sales/CTASection';
import { FooterSection } from '../components/sales/FooterSection';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-cream-DEFAULT overflow-x-hidden" data-id="element-260">
      <HeroSection data-id="element-261" />
      <ProblemSection data-id="element-262" />
      <MechanismSection data-id="element-263" />
      <SolutionSection data-id="element-264" />
      <SocialProofSection data-id="element-265" />
      <OfferSection data-id="element-266" />
      <FAQSection data-id="element-267" />
      <CTASection data-id="element-268" />
      <FooterSection data-id="element-269" />
    </main>;
}